/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import profile from '../images/avatar.svg';
import { FaGithub, FaTwitter } from 'react-icons/fa';

function Card() {
  return (
    <div className="w-full flex flex-row justify-center mx-auto">
      <div className="flex flex-col justify-center max-w-xs bg-white shadow-x1 rounded-x1 p-5">
        <div className="">
          <img
            className="w-32 mx-auto mt-3 shadow-xl rounded-full drop-shadow-sm"
            src={profile}
            alt="profile"
          />
        </div>
        <div className="text-center mt-5">
          <p className="text-x1 text-gray-900">Taiki</p>
          <p className="text-xs text-gray-600 pt-2 pb-4 px-5 inline-block border-b-2">Student</p>
        </div>
        <div className="flex items-center justify-center mt-3">
          <a
            href="https://github.com/Taiki0807 "
            className="text-xl p-1 text-gray-800 hover:bg-gray-800 rounded-full hover:text-white transition-colors duration-300"
          >
            <FaGithub />
          </a>
          <a
            href="https://twitter.com/Taikiweb1"
            className="text-xl p-1 ml-3 text-blue-600 hover:bg-blue-500 rounded-full hover:text-white transition-colors duration-300"
          >
            <FaTwitter />
          </a>
        </div>
      </div>
      <div className="text-xl w-1/4 bg-blue-500">
        <p className=" mt-4 text-2xl text-black font-extrabold text-center">Hey!There👋</p>
        <div className="flex flex-col justify-center h-5/6">
          <p className="font-extrabold text-lg text-white leading-snug mx-3">
            現在では、主にReactでフロントエンドを書いている学生です。学校では、Javaを習っています。また、C言語でマイコンの制御、Pythonで機械学習の勉強などもしています。よろしくお願いします。
          </p>
        </div>
      </div>
    </div>
  );
}

export default Card;
